import { useMemo } from 'react'
import { path } from 'ramda'
import { differenceInDays, parseISO } from 'date-fns'
import { shallowEqual, useSelector } from 'react-redux'

import { isEmptyOrNull } from '@/utils'

import { getFormattedDateUTC } from './utils'

const useIsListingInRecentMessages = (listingId: string): boolean => {
  const recentMessagesState = useSelector(
    state => path(['chat', 'recent_timeline_rooms'], state),
    shallowEqual
  )

  return useMemo(() => {
    if (isEmptyOrNull(recentMessagesState)) return false
    if (!Object.prototype.hasOwnProperty.call(recentMessagesState, listingId))
      return false

    const messageDate = recentMessagesState[listingId]?.last_message_date
    if (!messageDate) return false

    const currentDate = getFormattedDateUTC()
    const currentDateParsed = parseISO(currentDate)
    const messageDateParsed = parseISO(messageDate)

    return differenceInDays(currentDateParsed, messageDateParsed) < 60
  }, [recentMessagesState, listingId])
}

export default useIsListingInRecentMessages
